import React from 'react';
import _ from 'underscore';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import classnames from 'classnames';
import Router from 'components/Router';
import WarehouseNavigation from 'components/site/WarehouseNavigation';
import { Toaster } from '@cargomatic/ui';
import AdminWebAPIUtils from '../utils/AdminWebAPIUtils';
import SessionStore from '../stores/SessionStore';
import ToastStore from '../stores/ToastStore';
import SiteNav from './site/nav';
import ShipperNavigation from './site/shipper-nav';
import CarrierNavigation from './site/carrier-nav';
import ConsigneeNavigation from './site/consignee-nav';
// register action handlers
import '../utils/TripWebAPIUtils';
import '../utils/OrderWebAPIUtils';
import '../utils/EquipmentWebAPIUtils';

console.log(`Application running on ${window.location.href}...`);

function renderApp(nav, className) {
  const finalClassName = classnames({
    [className]: true,
  });
  return (
    <div className={finalClassName} id="site-nav">
      <Router nav={nav} />
      <Toaster />
      <ToastContainer
        autoClose={5000}
        closeOnClick
        draggable
        hideProgressBar={false}
        pauseOnHover
        pauseOnVisibilityChange
        position="top-right"
        rtl={false}
      />
    </div>
  );
}

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: SessionStore.isLoggedIn(),
      loading: true,
      user: SessionStore.getUser(),
      ldProvider: null,
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    SessionStore.addChangeListener(this.handleSessionStoreChange);
    ToastStore.addChangeListener(this.handleToastStoreChange);
    AdminWebAPIUtils.checkAuthToken(() => {
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    SessionStore.removeChangeListener(this.handleSessionStoreChange);
    ToastStore.removeChangeListener(this.handleToastStoreChange);
  }

  handleToastStoreChange = () => {
    const notification = ToastStore.getLatestNotification();
    if (!notification) {
      return;
    }

    const message = notification.body || notification.title;
    if (notification.level === 'error') {
      toast.error(message);
    } else if (notification.level === 'success') {
      toast.success(message);
    } else {
      toast(message);
    }
  };

  handleSessionStoreChange = () => {
    const newState = {};
    const isLoggedIn = SessionStore.isLoggedIn();
    if (isLoggedIn !== this.state.isLoggedIn) {
      newState.isLoggedIn = isLoggedIn;
      newState.loading = false;
    }

    const user = SessionStore.getUser();
    if (user !== this.state.user) {
      newState.user = user;
    }

    if (!_.isEmpty(newState) && this._isMounted) {
      this.setState(newState);
    }
  };

  renderPrivate() {
    const { user } = this.state;

    if (!user) {
      window.location.href = '/login';
    }

    let nav;
    switch (user._type) {
      case 'Admin':
        nav = SiteNav;
        break;
      case 'Shipper':
        nav = ShipperNavigation;
        break;
      case 'Carrier':
        if (SessionStore.isThirdPartyCarrier(user)) {
          // Third party carriers see limited nav
          nav = ConsigneeNavigation;
        } else {
          nav = CarrierNavigation;
        }
        break;
      case 'Consignee':
        nav = ConsigneeNavigation;
        break;
      case 'Warehouse':
        nav = WarehouseNavigation;
        break;
      default:
        return '';
    }

    return renderApp(nav, 'private-nav', true);
  }

  render() {
    const { loading, isLoggedIn } = this.state;

    if (loading) {
      return (
        <div className="flex h-screen justify-center items-center">
          <i className="fa fa-spinner fa-spin text-4xl text-green" />
        </div>
      );
    }
    if (isLoggedIn) {
      return this.renderPrivate();
    }
    return renderApp(null, 'public-nav');
  }
}
